const ITEMS = [
  "Follow your own path",
  "Lead with authenticity",
  "Create your own path",
  "TRAILNONE Run Club 001",
  "New drop live",
];

export const Marquee = () => (
  <div
    className="select-none overflow-hidden border-y border-border bg-background py-3.5"
    data-testid="brand-marquee"
  >
    <div className="marquee-track flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((t, i) => (
            <span
              key={i}
              className="flex items-center whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground"
            >
              <span className="px-6">{t}</span>
              <span className="text-signal">///</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
